import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "../../scenes/Home";
import PrivacyPolicy from "../../scenes/PrivacyPolicy";
import PrivacyPolicyEn from "../../scenes/PrivacyPolicyEn";
import DeleteProfileInfo from "../../scenes/DeleteProfileInfo";
import styled from "styled-components";

const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
`;

const RoutesComponent = () => {
  return (
    <Wrapper>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy/ua" element={<PrivacyPolicy />} />
          <Route path="/privacy-policy/en" element={<PrivacyPolicyEn />} />
          <Route path="/delete-profile-info/ua" element={<PrivacyPolicyEn />} />
          <Route path="/delete-profile-info" element={<DeleteProfileInfo />} />
        </Routes>
      </BrowserRouter>
    </Wrapper>
  );
};

export default RoutesComponent;
